import { FC, useEffect, useState } from "react";
import { useAuthStore } from "../../hooks/useAuthStore";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useInitialStepStore } from "../../hooks/useInitialStepStore";
import { ApiStatus } from "../../types/api/status";

const columns = [
    { type: 'text', field: 'order', label: 'Orden', align:'center' },
    { type: 'text', field: 'initialStep', label: 'Descripción', align:'center' },
    // { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const InformationCompany: FC = () => {

    const { user } = useAuthStore()
    const { status, detInitialSteps, getDetailInitialStep } = useInitialStepStore()

    useEffect(() => {
        getDetailInitialStep({ plan: user.membership })
    }, [])

    return (<>
        <Grid item xs={12}>
            <CustomTable
                title={'Pasos iniciales'}
                columns={columns}
                loading={status === ApiStatus.FETCHING}
                rows={detInitialSteps || []}
                onRowClick={() => { }}
                hasOptions
                dense
            />
        </Grid>
    </>)
}